import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { AppStateProvider } from "./components/state/AppProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
// Planing to use react-query for data fetching and server state management  instead of direct fetch calls
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";

import CodigoProducto from "./pages/CodigoProducto/CodigoProducto";
import ChatInit from "./pages/CodigoProducto/ChatInit";
import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import OneShot from "./pages/oneshot/OneShot";
import ChatV2 from "./pages/chat/ChatV2";
import ChatByDescription from "./pages/chat/ChatByDescription";
import SingleChat from "./pages/singleChat/SingleChat";
import Auth from "./pages/auth/Auth";
import ProtectedRoute from "./utils/ProtectedRoute";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./auth/msalConfig";

initializeIcons();

const queryClient = new QueryClient();

export default function App() {
    const [authenticated, setAuthenticated] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    // Initialize authentication state from sessionStorage on app load
    useEffect(() => {
        const checkAuthState = () => {
            try {
                const authToken = sessionStorage.getItem("authToken");
                if (authToken) {
                    // No registrar el token en consola: esto corre en cada carga de la aplicacion.
                    setAuthenticated(true);
                } else {
                    setAuthenticated(false);
                }
            } catch (error) {
                console.error("Error checking auth state:", error);
                setAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        checkAuthState();
    }, []);

    const handleLogin = (token: string) => {
        sessionStorage.setItem("authToken", token);
        setAuthenticated(true);
    };

    const handleLogout = () => {
        sessionStorage.removeItem("authToken");
        setAuthenticated(false);
    };

    // Show loading screen while checking authentication
    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <QueryClientProvider client={queryClient}>
            <MsalProvider instance={msalInstance}>
                <AppStateProvider>
                    <BrowserRouter>
                        <Routes>
                            {/* Public route for authentication */}
                            <Route path="/auth" element={<Auth onLogin={(token?: string) => handleLogin(token || "")} />} />

                            {/* Protected routes */}
                            <Route element={<ProtectedRoute isAuthenticated={authenticated} />}>  {/* Cambiado a true para ingreso directo PRUEBAS */}
                                <Route path="/" element={<Layout backgroundImageChanged={false} onClick={() => {}} />} />
                                <Route index element={<ChatInit />} />
                                <Route path="/chatv2/:chatId" element={<ChatV2 />} />
                                <Route path="/codigoProducto" element={<CodigoProducto />} />
                                <Route path="/search-description/:description" element={<ChatByDescription />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </AppStateProvider>
            </MsalProvider>
        </QueryClientProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);
